export default __webpack_public_path__ + "static/media/sponsor-icon-active.e03f645c.webp";